export enum PoteauAction {
    DEPLACEMENT = 'deplacement'
}
